import React, { useEffect, useState } from "react";
import { FaShoppingCart } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { getTestList } from "../../api/api";
import CustomLoader from "../../common/loader/CustomLoader";
import CustomPagination from "../../common/CustomPagination";
import ServiceHeader from "../../ServiceComponents/ServiceHeader";
import { FaGreaterThan } from "react-icons/fa6";
import { getDepartmentInfo } from "../../utils/helper";

export default function PthologyDetailSection() {
  const [search, setSearch] = useState("");
  const { dept } = useParams();
  const [testData, setTestData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20; // YOU CAN CHANGE
  const serviceInfo = getDepartmentInfo(dept);
  console.log("checking service info", serviceInfo);

  useEffect(() => {
    fetchTestListData();
  }, []);

  const fetchTestListData = async () => {
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      Center_ID: "",
      search_key: "",
    };

    try {
      setLoading(true);
      const res = await getTestList(payload);

      const filterTests =
        res?.data?.data?.filter((item) => item.Package === "N") || [];

      setTestData(filterTests);
    } catch (error) {
      console.error("Error fetching test list:", error);
    } finally {
      setLoading(false);
    }
  };

  // FINAL FILTERING
  const filteredTests = testData
    ?.filter((t) => t?.Department?.toLowerCase() === dept?.toLowerCase())
    ?.filter((t) =>
      t?.service_name?.toLowerCase().includes(search.toLowerCase())
    );

  // PAGINATION LOGIC
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const paginatedTests = filteredTests.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="test-container">
      {/* <div className="breadcrumb">
        <span>Home</span> &gt; <span>Services</span> &gt;
        <span className="active-breadcrumb">{dept}</span>
      </div> */}
      <ServiceHeader
        // childClass="gastroenterologyBgSection"
        childClass={serviceInfo?.className}
        breadcrumb={
          <>
            Services <FaGreaterThan size={15} /> {serviceInfo?.title}
          </>
        }
        title={serviceInfo?.title}
      />

      <div className="header-row">
        <input
          type="text"
          className="search-input-btn"
          placeholder="Search for test and health checkup"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1); // Reset on search
          }}
        />
      </div>

      {loading && <CustomLoader />}

      <div className="card-grid">
        {paginatedTests?.length > 0
          ? paginatedTests.map((item, i) => (
            <div className="test-card" key={i}>
              <h3 className="test-title">{item?.service_name}</h3>

              {/* PRICE */}
              <span className="test-price">
                ₹{item?.price ? parseInt(item.price) : "N/A"}
              </span>

              {/* BUTTON ROW */}
              <div className="button-row">
                <button className="view-button">VIEW</button>
                <button className="book-button">
                  BOOK <FaShoppingCart size={14} />
                </button>
              </div>
            </div>
          ))
          : !loading && <p className="no-test-text">No tests found</p>}
      </div>

      {/* PAGINATION */}
      {filteredTests.length > itemsPerPage && (
        <div style={{ marginTop: "1rem" }}>
          <CustomPagination
            totalPages={filteredTests.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onChange={(page) => setCurrentPage(page)}
          />
        </div>
      )}
    </div>
  );
}
